export const maskedSSN = (value, ssnNumber) => {
  let SSN = ssnNumber?.replace(/-/g, '');
  let finalNumber = '';
  if (value !== 'hide') {
    if (value !== false && SSN) {
      for (let i = 0; i < SSN.length - value; i++) {
        SSN = SSN.substring(0, i) + 'X' + SSN.substring(i + 1);
      }
      SSN =
        SSN.substring(0, 3) +
        '-' +
        SSN.substring(3, 5) +
        '-' +
        SSN.substring(5, 9);
      finalNumber = SSN;
    } else {
      finalNumber = ssnNumber;
    }
  }
  return finalNumber;
};

export const maskedOther = (value, number) => {
  const incomingNumber = number;
  let finalNumber = '';
  if (value !== 'hide') {
    if (value !== false) {
      for (let i = 0; i < incomingNumber?.length; i++) {
        if (i < incomingNumber?.length - value) {
          finalNumber += 'X';
        } else {
          finalNumber += incomingNumber[i];
        }
      }
    } else {
      finalNumber = incomingNumber;
    }
  }
  return finalNumber;
};

export const maskTaxIDString = (taxid) => {
  return '*** *** ' + taxid.substr(-4);
};
